module.exports = __webpack_public_path__ + "img/volaille_francaise.acdc60d5.png";